import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["alt", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.svg)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "svg",
        innerHTML: _ctx.svg
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        alt: _ctx.alt,
        src: _ctx.dataSrc,
        onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
      }, null, 40, _hoisted_2))
}